import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-record\"><defs><style type=\"text/css\"></style></defs><path d=\"M516.096 74.752c-243.712 0-441.344 197.632-441.344 441.344s197.632 441.344 441.344 441.344 441.344-197.632 441.344-441.344-197.632-441.344-441.344-441.344z m0 819.712c-208.384 0-378.368-169.984-378.368-378.368s169.984-378.368 378.368-378.368 378.368 169.984 378.368 378.368-169.984 378.368-378.368 378.368z\" p-id=\"1152\" fill=\"#26a2ff\" /><path d=\"M516.096 263.68h-62.976v315.392h315.392v-62.976h-252.416v-252.416z\" p-id=\"1153\" fill=\"#26a2ff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/record.svg
// module id = 1XyD
// module chunks = 40